<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { mloc } from "module/utils";
  import { DocumentType, documentIcons } from "module/foundryDocuments";
  import { enabledDocumentTypes } from "module/store/IndexingDisabledStore";
  import type { SearchFilterConfig } from "module/store/Filters";

  import FilterOptionSausage from "./FilterOptionSausage.svelte";
  import { typeLabel } from "module/typeUtils";

  let {
    disabled = false,
    config,
  }: { disabled?: boolean; config: SearchFilterConfig } = $props();
  const dispatch = createEventDispatcher();

  let documentTypes = $derived(
    $enabledDocumentTypes.map((type) => {
      const selectedTypes = config.documentTypes.filter(
        (s) => s.split(":")[0] === type
      );

      const title = selectedTypes.length
        ? selectedTypes.map((type) => typeLabel(type)).join(", ")
        : typeLabel(type);

      return {
        id: type,
        name: typeLabel(type),
        title: title,
        selected:
          config.documentTypes.findIndex(
            (t) => t === type || t.split(":")[0] === type
          ) !== -1,
      };
    })
  );

  let actorType = $derived(
    documentTypes.find((type) => type.id === DocumentType.ACTOR)!
  );
  let itemType = $derived(
    documentTypes.find((type) => type.id === DocumentType.ITEM)!
  );

  function toggleType(type: DocumentType) {
    const types = new Set(config.documentTypes);

    const matches = config.documentTypes.filter(
      (t) => t === type || t.split(":")[0] === type
    );

    if (matches.length) {
      matches.forEach((t) => types.delete(t));
      types.delete(type);
    } else {
      types.add(type);
    }

    dispatch("change", { documentTypes: Array.from(types) });
  }
</script>

<h3>{mloc("FilterEditorSectionTypeSelection")}</h3>
<ul>
  {#if $enabledDocumentTypes.includes(DocumentType.ACTOR)}
    <FilterOptionSausage
      selected={actorType.selected}
      title={actorType.title}
      icon={documentIcons[actorType.id]}
      more
      {disabled}
      on:click={() => toggleType(DocumentType.ACTOR)}
      on:clickMore={() => dispatch("openModal", "actors")}
    />
  {/if}
  {#if $enabledDocumentTypes.includes(DocumentType.ITEM)}
    <FilterOptionSausage
      selected={itemType.selected}
      title={itemType.title}
      icon={documentIcons[itemType.id]}
      more
      {disabled}
      on:click={() => toggleType(DocumentType.ITEM)}
      on:clickMore={() => dispatch("openModal", "items")}
    />
  {/if}

  {#each documentTypes as type (type.id)}
    {#if type.id !== DocumentType.ACTOR && type.id !== DocumentType.ITEM}
      <FilterOptionSausage
        selected={type.selected}
        title={type.title}
        icon={documentIcons[type.id]}
        {disabled}
        on:click={() => toggleType(type.id)}
      />
    {/if}
  {/each}
</ul>

<style>
  h3 {
    padding: 0 1em 0.2em;
    border-bottom: 2px solid rgba(255, 255, 255, 0.2);
  }
  ul {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin: 0;
    padding: 0;
    margin-bottom: 1em;
    gap: 0.5em;
    padding: 0.4em 1em;
  }
</style>
